import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IActiveBroadcastResponse, IBroadcast, IDashboardResponse, IUpcomingBroadcastResponse } from '../../models';
import { APIConstants } from '../../common';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getDashboardData(): Observable<IDashboardResponse> {
    const now = new Date();

    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const day = now.getDate().toString().padStart(2, '0');

    const current_date = `${year}-${month}-${day}`;

    // Extract local time components
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const milliseconds = now.getMilliseconds().toString().padStart(3, '0');

    // Simulate microseconds by appending '000' to milliseconds
    const microseconds = '000';

    const current_time = `${hours}:${minutes}:${seconds}.${milliseconds}${microseconds}`;

    const url = `${APIConstants.dashboard}?current_date=${current_date}&current_time=${current_time}`;

    return this.http.get<IDashboardResponse>(url);
  }

  getAllActiveBroadcasts(): Observable<IActiveBroadcastResponse> {
    return this.http.get<IActiveBroadcastResponse>(APIConstants.allActiveBrodcasts);
  }

  getAllUpcomingBroadcasts(): Observable<IUpcomingBroadcastResponse> {
    return this.http.get<IUpcomingBroadcastResponse>(APIConstants.allUpcomingBrodcasts);
  }

  getScheduleProgressByDay(date: string): Observable<IBroadcast[]> {
    return this.http.get<IBroadcast[]>(APIConstants.scheduleProgressByDay + '?specific_date=' + date);
  }

}
